import React, { useState } from "react";
import { Box, Card as MuiCard, Typography } from "@alpha/ui-lib/ui/external";
import { makeStyles } from "@alpha/ui-lib/theme";
import MigrationCentreBannerPattern from "../../../assets/MigrationCentreBannerPattern.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import { faPlay } from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useTranslation } from "react-i18next";


const Card = MuiCard as React.FC<React.ComponentProps<typeof MuiCard>>;

export const useStyles = makeStyles(
  () => ({
    migrationOverviewBanner: {
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: '#1E87771A',
      borderRadius: '10px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '12px 16px',
      minHeight: '106px',
      boxShadow: 'none',
    },
    migrationOverviewBackground: {
      position: 'absolute',
      top: '-420px',
      right: '-180px',
      width: '1000px',
      height: '1000px',
      backgroundImage: `url(${MigrationCentreBannerPattern})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      pointerEvents: 'none',
    },
    migrationOverviewContent: {
      position: 'relative',
      zIndex: 1,
      color: '#1E8777',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    migrationOverviewDescription: {
      display: 'flex',
      flexDirection: 'column',
      margin: '12px',
      width: '60%',
      fontWeight: 400,
      '& h5': {
        marginBottom: '10px',
        fontSize: '16px',
        fontWeight: 600,
      },
    },
    closeButton: {
      position: 'absolute',
      top: '12px',
      right: '8px',
      cursor: 'pointer',
      color: '#000000',
      '&:hover': {
        color: '#000000BF',
      },
    },
    migrationOverviewVideo: {
      width: '145px',
      height: '82px',
      backgroundColor: '#3D1629',
      borderRadius: '5px',
      overflow: 'hidden',
      margin: '12px',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    videoOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1300,
    },
    videoPopup: {
      position: 'relative',
      width: '776px',
      height: '472px',
      backgroundColor: '#000',
      borderRadius: '8px',
      overflow: 'hidden',
    },
    videoPopupClose: {
      position: 'absolute',
      top: 0,
      right: 0,
      padding: '8px',
      cursor: 'pointer',
      color: '#FFFFFF',
      zIndex: 1,
    },
  }),
  { name: 'MigrationOverviewBanner' },
);

const MigrationOverviewBanner: React.FC = () => {
  const [showBanner, setShowBanner] = useState(true);
  const [showVideo, setShowVideo] = useState(false);
  const [expandVideo, setExpandVideo] = useState(false);
  const { t } = useTranslation();
  const classes = useStyles();

  const handleClose = () => {
    setShowBanner(false);
  }

  return (
    <>
    {showBanner && (
    <Card className={classes.migrationOverviewBanner}>
      <div className={classes.migrationOverviewBackground} />
      <div className={classes.migrationOverviewContent}>
        <Box className={classes.migrationOverviewDescription}>
          <Typography variant="h5">{t('migration_overview')}</Typography>
          <div>{t('migration_center_alert')}</div>
        </Box>
        <Box
          className={classes.migrationOverviewVideo}
          style={{ display: showVideo ? 'flex' : 'none' }}
          onClick={() => setExpandVideo(true)}
        >
          <FontAwesomeIcon icon={faPlay as IconProp} color="#FFFFFF80" style={{ width: '24px', height: '24px' }} />
        </Box>
        <Box className={classes.closeButton} onClick={handleClose}>
          <FontAwesomeIcon icon={faXmark as IconProp} />
        </Box>
      </div>
    </Card>
    )}
    {expandVideo && (
      <Box className={classes.videoOverlay} onClick={() => setExpandVideo(false)}>
        <Box className={classes.videoPopup} onClick={(e) => e.stopPropagation()}>
          <Box className={classes.videoPopupClose} onClick={() => setExpandVideo(false)}>
            <FontAwesomeIcon icon={faXmark as IconProp} size="lg" />
          </Box>
          <video width="776" height="472" controls autoPlay>
            <source src="https://userguides.rmportal.alpha.co.uk/Beneficiaries%20-%20International%20details.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Box>
      </Box>
    )}
    </>
  );
}

export default MigrationOverviewBanner;